export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  watch: {
    title: function title(newValue, oldValue) {
      if (newValue.length > 24) {
        this.title = newValue.substr(0, 24) + '......';
      }
    }
  },
  methods: {
    share: function share() {
      this.$toast('调用原生分享');
    },
    back: function back() {
      var _this = this;
      var timer = setTimeout(function () {
        _this.$router.back();
        clearTimeout(timer);
      }, 100);
    }
  }
};